"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEmitter = createEmitter;
function createEmitter(socket, event, request) {
    socket.emit(event, request);
}
